import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import styled from 'styled-components';

var defaultBorderWidth = 2;
var StyledDragHandle = styled.div.withConfig({
  displayName: "DragHandle__StyledDragHandle",
  componentId: "sc-jzrq80-0"
})(function (_ref) {
  var _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? defaultBorderWidth : _ref$borderWidth,
    disabled = _ref.disabled,
    isDragPlaceholder = _ref.isDragPlaceholder;
  return _objectSpread(_objectSpread({}, function () {
    if (isDragPlaceholder) {
      return {
        opacity: 0
      };
    }
  }()), {}, {
    display: "flex",
    position: "absolute",
    left: 0,
    borderRadius: 2,
    cursor: !disabled ? "grab" : "not-allowed",
    margin: -borderWidth,
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  });
});
StyledDragHandle.displayName = "StyledDragHandle";

export { StyledDragHandle };
